export { default as SavedCourses } from './LazySavedCourses';
export type {
  SavedCourseSnackbarState,
  SavedCoursesLocaleKeys,
  SavedCoursesProps,
} from './types';
